import { useEffect, useState } from "react";

const useRestaurantMenu = (id) => {
  const [menu, setMenu] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return; // Guard against undefined id

    const getMenuItem = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_URL}/api/restaurantMenu/${id}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const json = await response.json();
        setMenu(json);
      } catch (err) {
        console.error("Error fetching restaurant menu:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getMenuItem();
  }, [id]); // Re-fetch when id changes

  return { menu, loading, error };
};

export default useRestaurantMenu;